<div class="fullcontainer">
  <div class="sheet">
    <h1 class='header'>View POD - POD ID: {{ this.pod.id }}</h1>
    <hr />

    <app-tabs>
      <app-tab title='Details'>
        <h3>Main Details</h3>
        <div class='row form-group'>
          <div class='col form-row col-md-4'>
            <label>Pod Number</label>
            <input class='form-control' type='text' [value]='this.pod.id' readonly/>
          </div>
          <div class='col form-row col-md-4'>
            <label>Order Type</label>
            <input class='form-control' type='text' [value]='this.order.orderType.name' readonly/>
          </div>
          <div class='col form-row col-md-4'>
            <label>Vehicle</label>
            <input class='form-control' type='text' [value]='this.pod.vehicle.registration' readonly/>
          </div>
          <div class='col form-row col-md-4'>
            <label>Driver</label>
            <input class='form-control' type='text' [value]='this.pod.driver.firstName + " " + this.pod.driver.lastName' readonly/>
          </div>
          <div class='col form-row col-md-4'>
            <label>Account</label>
            <input class='form-control' type='text' [value]='this.order.account.name' readonly/>
          </div>
          <div class='col form-row col-md-4'>
            <label>Service</label>
            <input class='form-control' type='text' [value]='this.getService()' readonly/>
          </div>
          <div class='col form-row col-md-4'>
            <label>Unit</label>
            <input class='form-control' type='text' [value]='this.getUnit()' readonly/>
          </div>
          <div class='col form-row col-md-4'>
            <label>Site</label>
            <input class='form-control' type='text' [value]='this.order.site.name' readonly/>
          </div>
          <div class='col form-row col-md-4'>
            <label>Qty</label>
            <input class='form-control' type='text' [(ngModel)]='this.pod.qty'/>
          </div>
          <div class='col form-row col-md-4'>
            <label>Tip site</label>
            <input class='form-control' type='text' [value]='this.order.tipSite.name' readonly/>
          </div>
          @if (this.pod.siteStartTime !== "" && this.pod.siteStartTime) {
            <div class='col form-row col-md-4'>
              <label>Site Start Time</label>
              <input class='form-control' type='text' [value]='this.pod.siteStartTime' readonly/>
            </div>
          }
          @if (this.pod.siteEndTime !== "" && this.pod.siteEndTime) {
            <div class='col form-row col-md-4'>
              <label>Site End Time</label>
              <input class='form-control' type='text' [value]='this.pod.siteEndTime' readonly/>
            </div>
          }
          @if (this.pod.travelTime > 0) {
            <div class='col form-row col-md-4'>
              <label>Travel Time</label>
              <input class='form-control' type='text' [value]='this.pod.travelTime' readonly/>
            </div>
          }
          @if (this.pod.waitTime > 0) {
            <div class='col form-row col-md-4'>
              <label>Wait Time</label>
              <input class='form-control' type='text' [value]='this.pod.waitTime' readonly/>
            </div>
          }
          @if (this.pod.driverBreakTime && this.pod.driverBreakTime !== "") {
            <div class='col form-row col-md-4'>
              <label>Driver Break Time</label>
              <input class='form-control' type='text' [value]='this.pod.driverBreakTime' readonly/>
            </div>
          }
          @if (this.pod.chargeableTime && this.pod.chargeableTime !== "") {
            <div class='col form-row col-md-4'>
              <label>Chargable Time</label>
              <input class='form-control' type='text' [value]='this.pod.chargeableTime' readonly/>
            </div>
          }
          @if (this.pod.ticketNumber !== "" && this.pod.ticketNumber) {
            <div class='col form-row col-md-4'>
              <label>Ticket Number</label>
              <input class='form-control' type='text' [value]='this.pod.ticketNumber' readonly/>
            </div>
          }
        </div>

        <button class='btn btn-primary' (click)='this.createPDFFile()'>Download POD</button>
        <hr />

        <h3>Customer signature</h3>

        <small>{{ this.pod.customerName }}</small> <br /> <br />
        <small>Notes: {{ this.pod.comments }}</small><br /><br />
        <img [src]='this.pod.signature' style='height:12rem'/>
        <hr />


      </app-tab>

      <app-tab title='Evidence'>
        @for (image of this.images; track image) {
          <img style="height:12rem" src='data:{{image.filetype}};base64,{{image.data}}'/>
        }
      </app-tab>
      <app-tab title='Job History'>
        <table class='table'>
          <thead>
            <th>Date</th>
            <th>Time</th>
            <th>Status</th>
            <th>GPS</th>
            <th></th>
          </thead>
          <tbody>
            @for (status of this.history; track status) {
              <tr>
                <td>{{ status.date }}</td>
                <td>{{ status.time }}</td>
                <td>{{ getStatusFromId(status.driverJobStatusId).name }}</td>
                <td>{{ status.gpsLat }}.{{status.gpsLong }}</td>
                <td><a target='_blank' [href]='getMapUrl(status)' class='btn btn-primary'>View Map</a></td>
              </tr>
            }
          </tbody>
        </table>
      </app-tab>
    </app-tabs>

    <button type='button' class="btn btn-success" (click)='save()'>Save</button>&nbsp;
    <button type="button" class="btn btn-danger" routerLink='/pods'>Cancel</button>
  </div>
</div>
